import { DextTextInputWUT } from '@wix/form-fields/wut';

export default DextTextInputWUT;
